import { of } from 'rxjs'
import { switchMap } from 'rxjs/operators'

import { Institution } from '@skinsoft/types'
import { DataStore } from '@skinsoft/data-store'

export class InstitutionDataStore extends DataStore<Institution> {

    public static getInstance() {
        if (!InstitutionDataStore.instance) {
            InstitutionDataStore.instance = new InstitutionDataStore();
        }

        return InstitutionDataStore.instance;
    }

    public static install(Vue) {
        Vue.prototype.$institutionDataStore = InstitutionDataStore.getInstance();
    }

    private static instance: InstitutionDataStore = null as any;

    constructor() {
        super('/institution');
    }

    public fetchAllByWorkspace(workspaceId: string) {
        return this.proxy.fetch(`/institution/byWorkspaces?workspaces=${workspaceId}`).pipe(
            switchMap(institutions => {
                this.offlineDataFetcher.append(institutions?._embedded?.institution)
                return of(institutions)
            })
        )
    }
}